import React, {useEffect, useMemo} from "react";
import {ImageContainer} from "./ImageSection.style";

export const ImageSection = ({image}) => {
    const isBlobLike = image instanceof Blob;
    const isStringUrl = typeof image === "string" && image.trim().length > 0;

    const objectUrl = useMemo(() => {
        if (!isBlobLike) return null;
        return URL.createObjectURL(image);
    }, [image, isBlobLike]);

    useEffect(() => {
        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [objectUrl]);

    const src = isBlobLike ? objectUrl : isStringUrl ? image : null;

    if (!src) return <section/>;

    return (
        <section>
            <ImageContainer>
                <img src={src}
                     alt="Preview"
                     className="details-image"
                />
            </ImageContainer>
        </section>
    );
};